<div [ngStyle]="chartStyleDefault">
  <canvas #chartCanvas></canvas>
</div>
<div [ngStyle]="chartStyleSnapshot">
  <canvas #chartSnapshotCanvas></canvas>
</div>
